export default __webpack_public_path__ + "locales/en/Common.json?hash=1bbb39ccd002a6c855a411765867fbcb";